import { usersService, bookersService, notificationService } from "@/_services";
import { campaignsService } from "@/_services";
import { router } from "@/_helpers";
import i18n from "@/_helpers/i18n";
import { store } from ".";
import { isNetworkError } from "./alert.module";

let user = null;
try {
  user =
    window.localStorage.getItem("xkhx$$") != null
      ? JSON.parse(
          decodeURIComponent(
            escape(atob(window.localStorage.getItem("xkhx$$")))
          )
        )
      : null;
  //window.localStorage.removeItem("xkhx$$");
} catch (error) {
  user = null;
}
if (user && user.user && user.user.lang_code) {
  i18n.locale = user.user.lang_code;
}

function setSessionChange(authState) {
  const encodedAuthState = btoa(
    unescape(encodeURIComponent(JSON.stringify(authState)))
  );
  localStorage.setItem("authState", encodedAuthState);
}

const permissions = {
  basicFunctionalities: [1, 5, 6, 2, 3, 4, 7, 8, 9],
  campaigns: [1, 5, 6, 4, 2, 3, 7, 8],
  calendarAndEmailsSync: [1, 3, 4, 2, 8],
  crm: [1, 3, 4, 2],
  opportunitiesList: [1, 5, 6, 2, 3, 4, 7],
  createAccount: [1, 2, 3, 4],
  manageSalesRep: [1, 5, 6, 2, 4, 7],
  manageBilling: [1, 5, 6, 7, 2, 4],
  manageBusinessContacts: [1, 2, 3, 5, 6],
  adminBusinessContacts: [1, 2, 3, 4],
  managePayments: [1, 2, 4],
  superAdminTargets: [1, 5, 8],
  adminTargets: [1, 5, 6, 3, 4, 7, 8],
  manageTargets: [1, 2, 4, 8],
  manageClients: [1, 2, 4, 8],
  adminClients: [1, 5, 6, 7, 8],
  isAgencyManager: [5, 6, 7],
  agencyAccountManager: [1, 5, 6],
  isAdminAgency: [1, 2, 5, 6, 7],
  isReferal: [7],
  superAdmin: [1],
  adminAgency: [1, 5],
  noAdminBilling: [3, 4],
  clientAdminCommercial: [1, 2],
  billing: [4],
  sale: [3],
  AgencyBilling: [1, 4, 5],
  AgencyBillingOrSales: [1, 3, 4, 5],
  isTechnicalAgent: [8],
  isBdr: [2],
  isBookerManager: [9]
};

/** Billing/toast payload when skipping users/has-payment-default (roles 1 & 2). */
const DEFAULT_TOAST_NOTIFICATION_DATA = {
  credits: { total: 0, attempts: "0", from: "0", to: "0", left: 0 },
  trialPeriodData: {
    trial_period_ended: 0,
    days: 0,
    end_date: "",
    end_date_string: "",
    contacts_left: 0
  },
  hasDefaultPaymentMethod: [],
  hasDeclinedPayments: [],
  dontChargePayments: 0,
  hasPendingPayments: false,
  subscriptionActive: 0,
  notifications: 0,
  campaignsWithNoEmailsSent: [],
  campaignactivelimit: 0
};

const initialState = user
  ? user
  : {
      status: {},
      user: null,
      notifications: 0,
      isEmailSync: false,
      notificationspopup: [],
      toastNotificationData: {
        ...DEFAULT_TOAST_NOTIFICATION_DATA
      },
      isAppAvailable: false
    };

export const authentication = {
  namespaced: true,
  state: initialState,
  creatingAccount: false,
  actions: {
    login({ dispatch, commit }, { username, password }) {
      return new Promise((resolve, reject) => {
        commit("loginRequest", { username });
        usersService.login(username, password).then(
          (user) => {
            commit("loginSuccess", user);
            dispatch("getToastNotificationData");

            i18n.locale = user.lang_code;
            setSessionChange(store.state.authentication); //Funcion para validar el cambio de loggin de diferentes users
            // TODO delete this
            localStorage.setItem("priorityCategoryFilter", JSON.stringify({}));
            localStorage.setItem("priorityProductFilter", JSON.stringify({}));

            resolve("ok");
          },
          (error) => {
            commit("loginFailure", error);
            dispatch(
              "alert/newError",
              {
                message: error,
                section: "login",
                url: "/users/login",
                method: "POST",
              },
              { root: true }
            );
            reject("error");
          }
        );
      });
    },

    refreshToken({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        usersService.refreshToken().then(
          (user) => {
            commit("loginSuccess", user);
            dispatch("getToastNotificationData");
            resolve("ok");
          },
          (error) => {
            commit("loginFailure");
            // Un refresco fallido no es lo mismo que "no pudimos conectarte":
            // si la red anduvo, lo que caduco es la sesion. Antes los dos casos
            // mostraban el mismo texto y el usuario no entendia por que volvia
            // a la pantalla de login estando ya dentro de la app.
            dispatch(
              "alert/newError",
              {
                message: isNetworkError(error) ? error : "expired",
                section: "login",
                fallbackKey: "login.error.expired",
                url: "/users/refresh-token",
                method: "POST",
              },
              { root: true }
            );
            localStorage.setItem(
              "afterLoginGoTo",
              router.currentRoute.fullPath
            );
            router.push("/login");
            // router.push({ name: 'login', query: { redirect: router.currentRoute.fullPath } });
            reject("error");
          }
        );
      });
    },

    verificationcode(
      { dispatch, commit },
      { code, username, password, clientId }
    ) {
      if (username == "") {
        commit("emailNotVerified");
        usersService.verificationCodeLoggedIn(code).then(
          (args) => {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: "Creation_Compte - Compte Validé",
              user_Mail: args.username,
              user_Phone: args.phone,
            });

            commit("emailVerified");
          },
          (error) => {
            dispatch("alert/error", error, { root: true });
          }
        );
      } else {
        usersService.verificationCode(code, username, password, clientId).then(
          (args) => {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: "Creation_Compte - Compte Validé",
              user_Mail: args.username,
              user_Phone: args.phone,
            });

            dispatch("login", {
              username: args.username,
              password: password,
              redirectDashboard: false,
            }).then((result) => {
              commit("emailVerified");
            });
          },
          (error) => {
            dispatch("alert/error", error, { root: true });
          }
        );
      }
    },

    resendVerificationCode({ dispatch, commit }, { username }) {
      dispatch("alert/clear", {}, { root: true });
      return new Promise((resolve, reject) => {
        username = username == "" ? user.user.username : username;
        usersService.resendVerificationCode(username).then(
          (args) => {
            resolve("ok");
          },
          (error) => {
            dispatch("alert/error", "Server error", { root: true });
            reject("error");
          }
        );
      });
    },

    create({ dispatch, commit }, { dataUser }) {
      commit("createAccount", true);
      dispatch("alert/clear", {}, { root: true });

      return new Promise((resolve, reject) => {
        usersService.create(dataUser).then(
          (user) => {
            commit("createAccount", false);
            if (!dataUser.fromAdmin) {
              commit("emailSent");
            }
            console.log("module");
            console.log(user);
            resolve(user);
          },
          (error) => {
            dispatch(
              "alert/newError",
              { message: error, section: "user" },
              { root: true }
            );
            reject(error);
          }
        );
      });
    },

    createBooker({ dispatch, commit }, { dataUser }) {
      commit("createAccount", true);
      dispatch("alert/clear", {}, { root: true });

      return new Promise((resolve, reject) => {
        bookersService.bookerCreateAccount(dataUser).then(
          (user) => {
            commit("createAccount", false);
            if (!dataUser.fromAdmin) {
              commit("emailSent");
            }
            console.log("module");
            console.log(user);
            resolve(user);
          },
          (error) => {
            if(error.result != 'notunique'){
              dispatch(
                "alert/newError",
                { message: i18n.t('lang.user.error.notunique') },
                { root: true }
              );
              reject(error);
            }else{
              dispatch(
                "alert/newError",
                { message: i18n.t('lang.general.error')},
                { root: true }
              );
              reject(error);
            }
          }
        );
      });
    },

    addNewUser({ dispatch, commit }, { dataUser }) {
      dispatch("alert/clear", {}, { root: true });
      return new Promise((resolve, reject) => {
        usersService.addNewUser(dataUser).then(
          (user) => {
            // commit('emailSent');
            resolve("ok");
          },
          (error) => {
            dispatch(
              "alert/newError",
              { message: error, section: "user" },
              { root: true }
            );
            reject("error");
          }
        );
      });
    },

    requestNewPassword({ dispatch, commit }, { email }) {
      let message = "Nous traitons votre demande.";
      dispatch("alert/success", message, { root: true });
      usersService.requestNewPassword(email).then(
        (response) => {
          message =
            "Un nouveau mot de passe vous a été envoyé par mail (Pensez à vérifier vos spams )";
          dispatch("alert/success", message, { root: true });
        },
        (error) => {
          dispatch("alert/error", error, { root: true });
        }
      );
    },

    logout({ commit }) {
      usersService.logout();
      commit("logout");
    },

    setNotifications({ dispatch, commit }, cant) {
      commit("setNotifications", cant);
    },

    watchVideo({ dispatch, commit }, yes) {
      commit("watchVideo", yes);
    },

    getIsEmailSync({ dispatch, commit }) {
      usersService.getEmailSettings().then((result) => {
        let isEmailSync = false;
        if (result.email && result.activated == 1) {
          isEmailSync = true;
        }
        commit("setIsEmailSync", isEmailSync);
      });
    },

    setIsEmailSync({ dispatch, commit }, isEmailSync) {
      commit("setIsEmailSync", isEmailSync);
    },

    getToastNotificationData({ state, commit }) {
      return new Promise((resolve, reject) => {
        if (!state.user) {
          resolve("ok");
          return;
        }
        const roleId = parseInt(state.user.role_id, 10);
        if (roleId === 1 || roleId === 2) { // Prohibir la  ejecucion en bucle de este endpoint para estos roles
          commit(
            "setToastNotificationData",
            JSON.parse(JSON.stringify(DEFAULT_TOAST_NOTIFICATION_DATA))
          );
          resolve("ok");
          return;
        }
        usersService.hasPaymentDefault().then(
          (toastNotificationData) => {
            if (toastNotificationData !== undefined) {
              commit("setToastNotificationData", toastNotificationData);
            }
            resolve("ok");
          },
          (error) => {
            reject("error");
          }
        );
        /*notificationService.getTasksPopup().then(
          notificationspopup => {
            if (notificationspopup !== undefined) {
              commit('setNotificationPopupData', notificationspopup);
            }
          }
        ).catch((err) => {

        });*/
      });
    },

    setLangCode({ dispatch, commit }, langCode) {
      i18n.locale = langCode;
      commit("setLangCode", langCode);
    },
    setAvatarUser(context, value) {
      context.commit("setAvatarUser", value);
    },
  },
  getters: {
    hasPermissions: (state) => (permission) => {
      if (Array.isArray(permission)) {
        let hasPermissions = false;
        permission.forEach((p) => {
          if (permissions[p].includes(parseInt(state.user.role_id))) {
            hasPermissions = true;
          }
        });
        return hasPermissions;
      }
      return permissions[permission].includes(parseInt(state.user.role_id));
    },
    isUserOliverSale: (state) => {
      return state.user && state.user.role_id == 1 && state.user.user_constraint_id == 2;
    },
    isUserOperational: (state) => {
      return state.user && state.user.role_id == 1 && state.user.user_constraint_id == 1;
    },
    isUserAccountExecutive: (state) => {
      return state.user && state.user.role_id == 1 && state.user.user_constraint_id == 3;
    },
    isSaleOrAccountExecutive: (state) => {
      return state.user && state.user.role_id == 1 && ['2', '3'].includes(state.user.user_constraint_id);
    }
  },
  mutations: {
    loginRequest(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    setNotifications(state, cant) {
      state.notifications = cant;
    },
    watchVideo(state, yes) {
      state.watchvideo = yes;
    },
    setIsEmailSync(state, isEmailSync) {
      state.isEmailSync = isEmailSync;
      localStorage.setItem(
        "xkhx$$",
        btoa(unescape(encodeURIComponent(JSON.stringify(state))))
      );
    },
    setLangCode(state, langCode) {
      state.user.lang_code = langCode;
      localStorage.setItem(
        "xkhx$$",
        btoa(unescape(encodeURIComponent(JSON.stringify(state))))
      );
    },
    loginSuccess(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    emailNotVerified(state) {
      state.status = { loggedIn: true, emailSent: false, emailVerified: false };
    },
    emailVerified(state) {
      state.status = { loggedIn: true, emailSent: true, emailVerified: true };
      state.user.verificationcode = null;
      localStorage.setItem(
        "xkhx$$",
        btoa(unescape(encodeURIComponent(JSON.stringify(state))))
      );
    },
    emailSent(state) {
      state.status = { emailSent: true };
    },
    createAccount(state, value) {
      state.creatingAccount = value;
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {};
      state.user = null;
    },
    setNotificationPopupData(state, notificationspopup) {
      if (notificationspopup !== undefined && notificationspopup.length > 0)
        state.notificationspopup = notificationspopup;
    },
    setAvatarUser(state, value) {
      state.user.avatar = value;
    },

    setToastNotificationData(state, toastNotificationData) {
      state.toastNotificationData = toastNotificationData;
      state.notifications = toastNotificationData.notifications;
      state.isAppAvailable = true; // isAppAvailable;
      localStorage.setItem(
        "xkhx$$",
        btoa(unescape(encodeURIComponent(JSON.stringify(state))))
      );
    },
  },
};
